import { SVGProps } from 'react';

export const PlusCircle = (props: { className?: string } & SVGProps<SVGSVGElement>) => (
  <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.5 8.404v8m-4-4h8m6 0c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Z"
      stroke="currentcolor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
